module.exports = __webpack_public_path__ + "media/images/questionnaire_examples/logo_testing1-bd0ea7c2779b2d0f60dbf5363994699b.png";